var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCFlatSeatStandard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#a3c5e6",
  d: "M0 28V5a5 5 0 0 1 5-5h14a4.73 4.73 0 0 1 5 4.67V28z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#64a5e5",
  d: "M0 24h24v4H0z"
})));
export { SvgCFlatSeatStandard as ReactComponent };